module.exports = __webpack_public_path__ + "img/152.e356b47f.jpg";